import React from 'react';
import Dropdownarrrow from '../Assets/Icons/dropdownarrow.jpg';
import Dropdownarrrowwhite from '../Assets/Icons/Dropdownarrrowwhite.png';

function SelectInput({ selectDropDownData }) {
  const {
    optionString,
    textColor,
    selectModalContent,
    handleOpenandCloseModal,
    open,
  } = selectDropDownData;

  return (
    <section
      className={`${optionString === 'countrycode' ? 'w-fit' : 'w-full'}`}
    >
      <div
        className={`w-full h-11 rounded  flex items-center ${
          textColor === 'white' ? 'text-p-wh px-2' : 'text-p-bk border-hf px-4'
        }`}
        onClick={() => handleOpenandCloseModal(open)}
      >
        <div
          className={`flex flex-row items-center  font-normal  justify-between  ${
            optionString === 'countrycode' || optionString === 'dashboard'
              ? 'gap-3'
              : ' justify-between w-full'
          }`}
        >
          {!!selectModalContent ? (
            <>
              <div className='flex flex-row gap-3 items-center'>
                <img
                  src={selectModalContent?.flag}
                  alt={selectModalContent?.name}
                  className='w-6 h-4'
                />

                {optionString === 'countrycode' ? (
                  <p>{selectModalContent?.code}</p>
                ) : optionString === 'dashboard' ? (
                  <p>{selectModalContent?.name}</p>
                ) : (
                  <p>{selectModalContent?.name}</p>
                )}
              </div>
            </>
          ) : (
            <p className=' '>Select....</p>
          )}

          <img
            src={textColor === 'white' ? Dropdownarrrowwhite : Dropdownarrrow}
            alt='Dropdownarrrow icon'
            className='w-2'
          />
        </div>
      </div>
    </section>
  );
}

export default SelectInput;
